module.exports = {
	"id": "TD",
	"name": "Chad",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.004565,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005395,
			"17": 0.00249,
			"18": 0.00083,
			"19": null,
			"20": null,
			"21": 0.00415,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.001245,
			"26": 0.002905,
			"27": null,
			"28": 0.00415,
			"29": null,
			"30": 0.001245,
			"31": 0.005395,
			"32": 0.002075,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.00996,
			"41": 0.00083,
			"42": 0.002075,
			"43": 0.005395,
			"44": 0.002905,
			"45": 0.100845,
			"46": null,
			"47": 0.00996,
			"48": 0.006225,
			"49": 0.02822,
			"50": null,
			"51": 0.00747,
			"52": 0.020335,
			"53": 0.84411,
			"54": 0.160605,
			"55": 0.010375,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.81174,
			"4": 0.002075,
			"5": 0.001245,
			"6": 0.003735,
			"7": 0.00083,
			"8": 0.00083,
			"9": 0.00498,
			"10": 0.008715,
			"11": 0.00996,
			"12": 0.002075,
			"13": 0.002075,
			"14": 0.00083,
			"15": 0.001245,
			"16": 0.009545,
			"17": 0.002905,
			"18": 0.00332,
			"19": null,
			"20": 0.003735,
			"21": 0.00083,
			"22": 0.00664,
			"23": 0.00166,
			"24": 0.00166,
			"25": 0.00664,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.033615,
			"30": 0.006225,
			"31": null,
			"32": null,
			"33": 0.006225,
			"34": null,
			"35": 0.002075,
			"36": 0.00166,
			"37": 0.0083,
			"38": 0.007055,
			"39": 0.00083,
			"40": 0.005395,
			"41": 0.006225,
			"42": 0.003735,
			"43": 0.07221,
			"44": 0.009545,
			"45": 0.009545,
			"46": 0.0249,
			"47": 0.125745,
			"48": 0.08798,
			"49": 0.73787,
			"50": 0.03486,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.01245
		},
		"opera": {
			"9": null,
			"11": 0.00083,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.003735,
			"19": 0.002905,
			"20": null,
			"21": 0.002075,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.00166,
			"30": 0.00415,
			"31": 0.01411,
			"32": 0.00083,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.00083,
			"37": 0.009545,
			"38": 0.004565,
			"39": 0.0083,
			"40": 0.053535,
			"41": 0.00581,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.002075,
			"11.1": null,
			"11.5": 0.00083,
			"11.6": 0.00581,
			"12.1": 0.003735
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.001245,
			"8": 0.00083,
			"9": 0.060175,
			"10": 0.01743,
			"3.1": null,
			"3.2": null,
			"5.1": 0.01826,
			"6.1": null,
			"7.1": 0.00664,
			"9.1": 0.00913
		},
		"ios_saf": {
			"8": 0,
			"10": 0.242408965862,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00653264113239,
			"8.1-8.4": 0.0120687776853,
			"9.0-9.2": 0.00575758201499,
			"9.3": 0.0878400333056
		},
		"android": {
			"3": 0,
			"4": 0.0310303669251,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00387879586563,
			"4.1": 0.111930966408,
			"4.2-4.3": 0.279827416021,
			"4.4": 0.641663658915,
			"4.4.3-4.4.4": 0.647204795866
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0547885743802,
			"9": 0.0114673760331,
			"10": 0.0242089049587,
			"11": 0.217880144628,
			"5.5": null
		},
		"op_mob": {
			"0": 5.56575882997,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.154604411944
		},
		"edge": {
			"12": 0.007055,
			"13": 0.019505,
			"14": 0.0249
		},
		"ie_mob": {
			"10": 0.0491348732394,
			"11": 0.200049126761
		},
		"bb": {
			"7": 0.014376,
			"10": null
		},
		"samsung": {
			"0": 0.737968
		},
		"and_uc": {
			"0": 8.1464
		},
		"op_mini": {
			"0": 74.9865007581
		},
		"and_chr": {
			"0": 2.647387
		},
		"and_ff": {
			"0": 0.009584
		}
	},
	"total": 98.508222
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TD.json
 ** module id = 656
 ** module chunks = 0
 **/